<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <div class="railroad-grid-container" style="display: flex; flex-direction: column">
        <dx-data-grid
            bds-grid
            id="bdsReportGrid"
            [dataSource]="gridSource"
            height="80vh"
            minHeight="200px"
        >
            <dxi-column
                dataField="origin_code"
                dataType="string"
                caption="Origin Code"
                width="150px"
            ></dxi-column>
            <dxi-column
                dataField="Origin"
                cellTemplate="originTemplate"
                caption="Origin"
                width="auto"
                [minWidth]="100"
                allowSearch="true"
            ></dxi-column>

            <div *dxTemplate="let item of 'originTemplate'">
                <p class="">{{ item.data.orig_city }} {{ item.data.orig_state }}</p>
            </div>
            <dxi-column dataField="fleet_id" dataType="string" caption="Fleet"></dxi-column>
            <dxi-column dataField="business_group" dataType="string" caption="Grp"></dxi-column>
            <dxi-column dataField="aidle_days" dataType="number" caption="Avg. Idle Days"
                ><dxo-format [precision]="2" valueFormat="###0.##"> </dxo-format
            ></dxi-column>
            <dxi-column
                dataField="tidle_days"
                dataType="number"
                caption="Total Idle Days"
            ></dxi-column>
            <dxo-summary>
                <dxi-total-item displayFormat="Total:" showInColumn="origin_code"></dxi-total-item>
                <dxi-total-item
                    column="aidle_days"
                    summaryType="avg"
                    displayFormat="{0}"
                    showInColumn="aidle_days"
                    valueFormat="###0.##"
                ></dxi-total-item>
                <dxi-total-item
                    column="tidle_days"
                    summaryType="sum"
                    displayFormat="{0}"
                    showInColumn="tidle_days"
                ></dxi-total-item>
            </dxo-summary>
        </dx-data-grid>
    </div>
</div>
